function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.function.bind.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import _pt from "prop-types";
var _excluded = ["variant", "icon", "compact", "start", "children", "className"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import classNames from 'classnames';
import { ListContext } from './ListContext';
import "./list.css";
export var List = function List(_ref) {
  var _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'unordered' : _ref$variant,
    icon = _ref.icon,
    compact = _ref.compact,
    start = _ref.start,
    children = _ref.children,
    className = _ref.className,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var classes = classNames('lm-List', {
    'lm-List--compact': compact
  }, "lm-List--".concat(variant), className);
  var Component = variant === 'ordered' ? 'ol' : 'ul';
  var getIcon = function getIcon() {
    return icon;
  };
  return /*#__PURE__*/React.createElement(ListContext.Provider, {
    value: {
      getIcon: getIcon,
      variant: variant
    }
  }, /*#__PURE__*/React.createElement(Component, _extends({
    className: classes
  }, otherProps, {
    style: variant === 'ordered' && start !== undefined ? _objectSpread({
      counterReset: "li ".concat(start - 1)
    }, otherProps.style) : _objectSpread({}, otherProps.style)
  }), children));
};
List.propTypes = {
  /** Add an optional ID to a `ul` or `ol` element with the class `lm-List`. */id: _pt.string,
  /** Add custom classes to a `ul` or `ol` element with the class `lm-List`. */className: _pt.string,
  /**
     * Set the list type. Icons should only be used with the `unordered` list type.
     * @default 'unordered'
     */
  variant: _pt.oneOf(['ordered', 'unordered']),
  /** Use with unordered lists if a custom bullet is desired. Pass an instance of an LMDS icon. */icon: _pt.element,
  /** Reduce the space between list items. */compact: _pt.bool,
  /** Specify a starting number on ordered lists, if starting at 1 is not ideal. */start: _pt.number,
  /** Pass `ListItem` components as children to a `ul` or `ol` element with the class `lm-List`. */children: _pt.node.isRequired
};